import { objectFilter } from 'component-library';
import { objectMap } from 'helper-functions-library';
import { filterConceptTables } from './filter-tables-by-concept.js';
import { filterPresentFront } from './filter-present-front.js';
import { returnObjectTitle } from './return-object-title.js';

/*this function is a pipe to convert the table settings into an object of the elements that can be displayed on the front end
Props:
	concept: (string) the concept that is being worked on
	tableSettings: (object) the table settings
*/
export function getFrontPresentationSettingsPipe(props) {
	let { tableSettings, concept } = props,
		filterFunction = filterConceptTables(concept),
		filteredTables = objectFilter( tableSettings, filterFunction),//get only this concepts tables
		objectSettingsOnly = objectMap(filteredTables, (value, key)=>{
			return  objectFilter( value['settings'], filterPresentFront); //filter out only those settings that have a 'present_front' setting
		}),
		mergedSettings = Object.assign({}, ...Object.values(objectSettingsOnly)), //merge all the settings into a single object
		objectTitled = objectMap(mergedSettings, returnObjectTitle); //return the values as the title setting

	delete objectTitled[concept]; //remove the concept setting

	return objectTitled;
}
